import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { cn } from "../../../lib/utils.js";
import { QuizBlank } from "../shared/quiz-blank.js";
import { NumberKeypad } from "../shared/number-keypad.js";
import "../../../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
/* empty css                                                                             */
import { QuizResultFeedback } from "../shared/quiz-result-feedback.js";
import { useTranslation } from "react-i18next";
import "../shared/quiz-style-context.js";
import { SubmitButton } from "../shared/submit-button.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { QuizHeader } from "../shared/quiz-header.js";
import { QuizSolveDescription } from "../shared/quiz-solve-description.js";
import { formatProblem } from "../../../utils/quiz-parser.js";
import { useFillBlankQuiz } from "../hooks/use-fill-blank-quiz.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function FillBlankQuizAdult({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  useKeypad = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false,
  onAnswerChange,
  disableSound = false,
  difficultyLevel,
  hideExplanation = false
}) {
  var _a;
  const { t } = useTranslation("quiz");
  const {
    answers,
    currentIndex,
    blankCount,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleBlankClick,
    handleInputChange,
    handleKeypadInput,
    handleKeypadClear,
    handleSubmit
  } = useFillBlankQuiz({
    quizId,
    quiz,
    onSolve,
    solveResult,
    showReallyTrue,
    isViewSolved,
    initialAnswers: initialAnswersProp,
    onAnswerChange
  });
  const renderedProblem = useMemo(() => {
    if (blankCount === 0) return [];
    return formatProblem(
      quiz.problem,
      `${quizId}-problem`,
      (index, content) => {
        var _a2, _b;
        const key = content || "";
        return /* @__PURE__ */ jsx(
          QuizBlank,
          {
            index,
            answers,
            currentIndex,
            isCorrect: isSolved ? (_a2 = solveResult == null ? void 0 : solveResult.corrects) == null ? void 0 : _a2[index] : null,
            isSolved,
            showCorrectAnswer: shouldShowCorrectAnswers,
            correctAnswer: (_b = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _b[index],
            onClick: () => handleBlankClick(index),
            onChange: (value) => handleInputChange(index, value, key),
            useKeypad,
            isViewSolved
          },
          `blank-${quizId}-${index}`
        );
      },
      quiz.additionalImages ?? void 0
    );
  }, [blankCount, currentIndex, isSolved, solveResult, shouldShowCorrectAnswers, quiz.problem, quizId, useKeypad, isViewSolved, handleBlankClick, handleInputChange, answers, quiz.additionalImages]);
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-6", useKeypad && !isSolved && "pb-48"), children: [
    /* @__PURE__ */ jsx(
      QuizHeader,
      {
        quizId,
        typeLabel: t("types.fillBlank.label"),
        title: quiz.title,
        difficultyLevel,
        image: quiz.image,
        imageMobile: quiz.imageMobile,
        desmos: quiz.desmos,
        vars: quiz.vars
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { delay: 0.1 },
        className: cn(
          "p-4 rounded-xl bg-gray-100",
          "text-xl text-gray-700",
          "[&_.formatProblem]:leading-relaxed",
          '[&_span[class*="inline-flex"]]:leading-normal'
        ),
        children: renderedProblem
      }
    ),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizResultFeedback,
      {
        isCorrect: (solveResult == null ? void 0 : solveResult.correct) ?? false,
        show: isSolved,
        correctAnswer: shouldShowCorrectAnswers ? (_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a.join(", ") : void 0,
        disableSound,
        isViewSolved
      }
    ),
    isSolved && (solveResult == null ? void 0 : solveResult.description) && !hideExplanation && /* @__PURE__ */ jsx(
      QuizSolveDescription,
      {
        description: solveResult.description,
        commentaryImages: quiz.commentaryImages,
        vars: quiz.vars,
        id: `${quizId}-desc`,
        actionVisible: !solveResult.correct,
        actionLabel: isShowingCorrectAnswers ? t("common.viewMyAnswer") : t("common.viewCorrectAnswer"),
        onActionClick: () => setIsShowingCorrectAnswers((v) => !v)
      }
    ),
    useKeypad && !isSolved && !isViewSolved && /* @__PURE__ */ jsx(
      NumberKeypad,
      {
        onInput: handleKeypadInput,
        onClear: handleKeypadClear,
        disabled: isSolved
      }
    )
  ] });
}
export {
  FillBlankQuizAdult
};
//# sourceMappingURL=fill-blank-adult.js.map
